var Modal = (function($) {

    // ### Elements
    var _s = {
      container: '.chm-block-modal',
      modal_close: '.chm-block-modal .modal-close'
    };

    // ### Reusable Functions
    var openModal = function(target) {
      target.addClass('active');
      $('body').addClass('scroll-lock');
    };

    var closeModal = function(target) {
      let memory = target.attr('data-memory');
      let cookieID = target.attr('data-cookie-id');

      if ( memory === 'weak' ) {
        sessionStorage.setItem("modal-"+cookieID, "hide");
      } else if ( memory === 'strong' ) {
        localStorage.setItem("modal-"+cookieID, "hide");
      }

      target.removeClass('active');
      $('body').removeClass('scroll-lock');
    };

    // ### Init
    var _init = function() {
      _bindEvents();

      // Display on page load
      $(_s.container).each(function() {
        let memory = $(this).attr('data-memory');
        let cookieID = $(this).attr('data-cookie-id');

        if ( $(this).hasClass('js-on-page-load') ) {
          if ( localStorage.getItem("modal-"+cookieID) !== 'hide' && sessionStorage.getItem("modal-"+cookieID) !== 'hide' ) {

            let delay = parseInt($(this).attr('data-delay')) * 1000; // convert to seconds
          
            setTimeout(() => {
              openModal($(this));
            }, delay);

          }
        }
      });
      
    };

    // ### Bind Events
    var _bindEvents = function() {
      // Open Modal
      $('a[href^="#"]').on('click', function(e) {
        e.preventDefault();

        let target = $(this).attr('href');
        if ( $(target).length > 0 && $(target).hasClass('chm-block-modal') ) {
          openModal($(target));
        }
      });

      // Close Modal
      $(_s.modal_close).on('click', function() {
        closeModal($(this).parents(_s.container));
      });

      $(_s.container).on('click', function(e) {
        if ( $(e.target).closest('.modal-content').length === 0 ) {
          closeModal($(this));
        }
      });
    
    };

    return {
      init: _init
    };

})(jQuery);